var ctrlopt = ctrlopt;

(function ($) {
  var apptBook = Drupal.appointmentBooking;
  var settings = Drupal.settings || {};
  var oab = settings.oab || {};
  // var oab_time_override = (Drupal.settings.oab.oab_override_time_format !== 'undefined') ? Drupal.settings.oab.oab_override_time_format : 0;
  var oab_time_override = oab.oab_override_time_format || 0;
  var oab_override_min_format = oab.oab_override_min_format || 0;
  var hide_atist_name = oab.hide_atist_name || 0;
  var override_artist_name_any = oab.override_artist_name_any || 0;
  var google_search_restrict_name = oab.google_search_restrict_name || 0;
  var artist_name_override = oab.artist_name_override || 0;
  var oab_date_format = settings.oab_date_format || 0;

  /* Concrete View */
  apptBook.ConfirmSection = function (container) {
    apptBook.ConfirmSection.superclass.constructor.call(this);
    this.id = 'confirmation';
    this.container = container;
    this.confContainer = container.find('.confirmation-container');
    this.lessons = this.confContainer.find('.your-lessons');
    this.lesson = this.lessons.find('.lesson').remove();
    this.location = this.confContainer.find('.location');
    this.dateTime = this.confContainer.find('.date-time');
    this.artistName = this.confContainer.find('.artist');
    this.minLabel = this.container.attr('data-minutes-label');
    this.amLabel = this.container.attr('data-am-label');
    this.pmLabel = this.container.attr('data-pm-label');
    this.displayAMPM = this.container.attr('data-am-pm-display');
    this.dateFormat = this.container.attr('data-date-format');
    this.yearSuffix = this.container.attr('data-year-suffix');
    this.daySuffix = this.container.attr('data-day-suffix');
    this.monthSuffix = this.container.attr('data-month-suffix');
    this.months = this.container.attr('data-month-names').split(',');
    this.totalDuration = 0;
  };

  ctrlopt.extend(apptBook.ConfirmSection, apptBook.AbstractSection);

  apptBook.ConfirmSection.prototype.onUpdate = function (data) {
    var me = this,
      aPgName = document.title + ' - Confirmation';

    if (data.sectionId === this.id) {
      this.confData = data.params;
      this.buildLessons(this.confData.services);
      this.buildLocation(this.confData.counter);
      this.buildDateTime(this.confData);
      this.buildArtistName(this.confData.calendar, this.confData.counter);
    }
  };

  apptBook.ConfirmSection.prototype.buildLessons = function (data) {
    var myData, myNode, myLName, myLTime,
      me = this;

    this.lessons.find('.lesson').remove();
    for (var i = 0, len = data.length; i < len; i += 1) {
      myData = data[i];
      myNode = this.lesson.clone();
      myLName = myData.name;
      myLTime = myData.total_duration;
      me.totalDuration += parseInt(myLTime);

      myNode.html(myLName + ' (' + myLTime + ' ' + this.minLabel + ')');
      this.lessons.append(myNode);
    }
  };

  apptBook.ConfirmSection.prototype.buildLocation = function (data) {
    var tpStr = '',
      googleStr = '',
      name = data.name,
      addr1 = data.address1,
      addr2 = data.address2,
      town = data.town,
      postCode = data.postcode,
      phone = data.phone,
      email = data.email,
      nameNode = this.location.find('.location-name'),
      addrNode = this.location.find('.location-address'),
      addr2Node = this.location.find('.location-address2'),
      townPostNode = this.location.find('.location-town-postcode'),
      phoneNode = this.location.find('.location-phone'),
      getDir = this.location.find('.location-direction-links');

    if (name) {
      nameNode.html(name);
      name = google_search_restrict_name ? '' : name;
      googleStr += name;
    } else {
      nameNode.hide();
    }

    if (addr1) {
      addrNode.html(addr1);
      googleStr += '+' + addr1;
    } else {
      addrNode.hide();
    }

    if (addr2) {
      addr2Node.html(addr2);
      googleStr += '+' + addr2;
    } else {
      addr2Node.hide();
    }

    if (town) {
      tpStr += town;
      googleStr += '+' + town;
    }

    if (postCode) {
      tpStr += tpStr === '' ? postCode : ', ' + postCode;
      googleStr += '+' + postCode;
    }

    if (tpStr === '') {
      townPostNode.hide();
    } else {
      townPostNode.html(tpStr);
    }

    if (phone) {
      phoneNode.html(phone);
    } else {
      phoneNode.hide();
    }

    getDir.attr('href', 'https://www.google.com/maps?daddr=' + encodeURIComponent(googleStr));
  };

  apptBook.ConfirmSection.prototype.buildDateTime = function (data) {
    var m, d, y, h, hSuffix, apptTimeStr, min,
      apptDate = this.convertTimeString(data.start_time),
      apptEndDate = new Date(apptDate.getTime()),
      dateNode = this.dateTime.find('.appt-date'),
      atCopy = dateNode.text(),
      me = this;

    me.calContainer = me.container.find('.appt-date-cal');
    me.addCalLink = me.calContainer.find('.add-cal-link');
    me.calLinksCont = me.calContainer.find('.cals-container');
    me.calLinks = me.calContainer.find('.date-time-link');

    if (me.calContainer.length) {
      var addCalLink = me.calContainer.find('.add-cal-link'),
        calLinks = me.calContainer.find('.date-time-link'),
        addCalTitle = me.calContainer.find('.add-cal-title').html() || 'MAC Appointment',
        addCalDesc = me.calContainer.find('.add-cal-desc').html() || "Your Makeup Appointment is booked! Please arrive ten minutes before your lesson. We're looking forward to seeing you in person.",
        addr1 = data.counter.address1 || '',
        addr2 = data.counter.address2 || '',
        town = data.counter.town || '',
        postcode = data.counter.postcode || '';
    }
    apptEndDate.setTime(apptEndDate.getTime() + parseInt(me.totalDuration) * 60000);
    dateNode.empty();

    m = this.months[apptDate.getMonth()];
    d = apptDate.getDate();
    y = apptDate.getFullYear();
    h = apptDate.getHours();
    min = apptDate.getMinutes();
    if (this.displayAMPM == 1) {
      hSuffix = h < 12 ? this.amLabel : this.pmLabel;
      if (oab_override_min_format) {
        h = h + ':' + (min === 0 ? '00' : min);
      }
      h = (oab_time_override ? h : (h + 11) % 12 + 1) + hSuffix;
    } else {
      h = h + ':' + (min === 0 ? '00' : min);
    }

    if (oab_date_format) {
      apptTimeStr = y + ' ' + this.yearSuffix + ' ' + (apptDate.getMonth() + 1) + ' ' + this.monthSuffix + ' ' + d + ' ' + this.daySuffix + ' ' + h;
    } else {
      apptTimeStr = this.dateFormat.replace(/m/, m).replace(/d/, d).replace(/y/, y).replace(/atCopy/, atCopy).replace(/h/, h);
    }

    dateNode.text(apptTimeStr);

    if (me.calContainer.length) {
      me.myCalendar = createCalendar({
        data: {
          device_mobile: site.client.isMobile,
          title: addCalTitle, // Event title
          start: new Date(apptDate.getTime()), // Event start date
          duration: me.totalDuration, // Event duration (IN MINUTES)
          end: new Date(apptEndDate.getTime()), // You can also choose to set an end time.
          address: addr1 + ', ' + town + ', ' + postcode,
          description: addCalDesc
        }
      });

      me.calLinks.each(function () {
        var $this = $(this);
        var calID = $(this).attr('data-cal');
        var data = $.grep(me.myCalendar, function (el, i) {
          if (el.calId.toLowerCase() === calID) {
            return el.calHref;
          }
        });
        var dataUri = data[0].calHref;

        createDownloadLink($this, dataUri, calID, 'calendar.ics');
        $this.on('click', function () {
          me.calLinksCont.toggleClass('expanded');
        });

        function createDownloadLink(anchorSelector, dataUri, calID, fileName) {
          var dateUriIE = '';
          var blobObject = null;

          if (window.navigator.msSaveOrOpenBlob && calID !== 'google') {
            dateUriIE = dataUri.split(',')[1];
            dateUriIE = decodeURIComponent(dateUriIE);
            var fileData = [dateUriIE];

            blobObject = new Blob(fileData);
            $(anchorSelector).click(function (e) {
              e.preventDefault();
              window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            });
          } else {
            $(anchorSelector).attr('href', dataUri);
          }
        }
      });
      me.addCalLink.on('click', function () {
        me.calLinksCont.toggleClass('expanded');
      });
    }
  };

  apptBook.ConfirmSection.prototype.buildArtistName = function (data, counters_data) {
    var aName = data.public_name,
      aNameNode = this.artistName.find('.artist-name');
    var aName_text_override = this.artistName.find('.artist-text').html();
    var aName_override = this.artistName.find('.artist-text').html() + counters_data.name;

    if (aName === 'Any' && hide_atist_name) {
      aNameNode.css('display', 'none');
    } else if (aName === 'Any' && artist_name_override) {
      aNameNode.html(aName_text_override);
    } else if (aName === 'Any' && override_artist_name_any && aName_override) {
      aNameNode.html(aName_override);
    } else {
      aNameNode.html(aName);
    }
  };

  apptBook.ConfirmSection.prototype.convertTimeString = function (tString) {
    var split, dateArray, timeArray, y, m, d, hr, min, sec;

    split = tString.split(' ');
    dateArray = split[0].split('-');
    timeArray = split[1].split(':');

    y = parseInt(dateArray[0], 10);
    m = parseInt(dateArray[1], 10) - 1;
    d = parseInt(dateArray[2], 10);
    hr = parseInt(timeArray[0], 10);
    min = parseInt(timeArray[1], 10);
    sec = parseInt(timeArray[2], 10);

    return new Date(y, m, d, hr, min, sec);
  };

  Drupal.behaviors.apptBookConfirm = {
    attach: function (context) {
      var view = new apptBook.ConfirmSection($('#confirmation'));

      view.setModel(apptBook.sectionModel).startObserving();
    }
  };
})(jQuery);
